
    import {
      getAllCardPaymentConfigs,
      createCardPaymentConfig,
      createAllCardPaymentConfigs,
      updateCardPaymentConfig,
      deleteCardPaymentConfig
    } from "@/services/cardPaymentConfig";

    const state = {
      cardPaymentConfigs: [],
      processed: false
    };

    const getters = {
      getCardPaymentConfigs(state) {
        return state.cardPaymentConfigs;
      },
      cardPaymentConfigProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchCardPaymentConfigs({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllCardPaymentConfigs(
              params
            )
              .then(response => {
                commit("SET_CARDPAYMENTCONFIGS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createCardPaymentConfig({ commit }, cardPaymentConfig) {
          return new Promise((resolve, reject) => {
            createCardPaymentConfig(cardPaymentConfig)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllCardPaymentConfigs({ commit }, cardPaymentConfigs) {
          return new Promise((resolve, reject) => {
            createAllCardPaymentConfigs(cardPaymentConfigs)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateCardPaymentConfig({ commit }, cardPaymentConfig) {
          return new Promise((resolve, reject) => {
            updateCardPaymentConfig(cardPaymentConfig)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteCardPaymentConfig({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteCardPaymentConfig(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_CARDPAYMENTCONFIGS(state, data) {
        state.cardPaymentConfigs = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    